module.exports = __webpack_public_path__ + "static/img/shequ.96b14e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daping/shequ.png
// module id = HjOO
// module chunks = 0